import React, { useState, useRef } from 'react';

export default function BoissonPill({ boisson, maQuantite, onIncrement, onDecrement, disabled }) {
  const { nom, emoji, quantite_souhaitee, nombre_participants, categorie } = boisson;
  const totalPris = Number(nombre_participants) || 0;
  const autresQuantite = totalPris - maQuantite;
  const isFull = totalPris >= quantite_souhaitee;
  const [shaking, setShaking] = useState(false);
  const ref = useRef(null);

  const minePct = Math.min(100, (maQuantite / quantite_souhaitee) * 100);
  const autresPct = Math.min(100 - minePct, (autresQuantite / quantite_souhaitee) * 100);

  const triggerShake = () => {
    setShaking(true);
    setTimeout(() => setShaking(false), 300);
  };

  const handleClick = (e) => {
    if (disabled || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const mineWidthPx = rect.width * (minePct / 100);
    const autresWidthPx = rect.width * (autresPct / 100);

    if (clickX < mineWidthPx) {
      if (maQuantite > 0) onDecrement(boisson.id);
    } else if (clickX < mineWidthPx + autresWidthPx) {
      triggerShake(); // zone prise par d'autres invités : pas d'action
    } else {
      if (!isFull) onIncrement(boisson.id);
      else triggerShake();
    }
  };

  return (
    <div
      ref={ref}
      className={`boisson-pill${maQuantite > 0 ? ' selected' : ''}${isFull && maQuantite === 0 ? ' full' : ''}${shaking ? ' shake' : ''}`}
      onClick={handleClick}
      role="group"
      aria-label={`${nom}, ${maQuantite} pris par toi, ${totalPris} sur ${quantite_souhaitee} au total`}
    >
      <div className={`pill-fill pill-fill-mine ${categorie}`} style={{ left: 0, width: `${minePct}%` }} />
      <div className={`pill-fill pill-fill-others ${categorie}`} style={{ left: `${minePct}%`, width: `${autresPct}%` }} />

      <div className="pill-content">
        <span className="pill-emoji">{emoji}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="pill-name">{nom}</div>
          <div className="pill-count">
            {totalPris}/{quantite_souhaitee} {isFull ? '— Complet' : `place${quantite_souhaitee - totalPris > 1 ? 's' : ''} dispo`}
          </div>
        </div>
      </div>
    </div>
  );
}
